import React, { useState } from 'react';
import { Badge, IconButton, Dialog, Slide, Box, Typography, Divider } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useContent } from '../../../../context/ContentContext';

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));

const NotificationBadge = () => {
    const { Notifications = [], markNotificationAsRead } = useContent(); // Fallback to an empty array
    const [open, setOpen] = useState(false);

    // Count unread notifications
    const unreadCount = Notifications?.filter((notif) => !notif.read).length || 0;

    const handleDialogOpen = () => {
        setOpen(true); // Open the dialog
    };

    const handleDialogClose = () => {
        setOpen(false);
    };

    const handleNotificationClick = async (notifId) => {
        if (markNotificationAsRead) {
            await markNotificationAsRead(notifId); // Mark notification as read
        }
    };

    return (
        <>
            {/* Button with Notification Icon and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleDialogOpen}>
                <IconButton color="inherit">
                    <Badge badgeContent={unreadCount} color="error">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                <Typography variant="body1" sx={{ ml: 1 }}>
                    Notifikasi
                </Typography>
            </Box>
            {/* Dialog to display notifications */}
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleDialogClose}
                TransitionComponent={Transition}
            >
                <Box sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Notifications
                    </Typography>
                </Box>
                <Divider />

                {/* Handle notifications display */}
                {Notifications.length > 0 ? (
                    <Box>
                        {Notifications.map((notification) => (
                            <React.Fragment key={notification.id}>
                                <Box
                                    sx={{ p: 2, cursor: 'pointer', bgcolor: notification.read ? 'inherit' : 'lightblue' }}
                                    onClick={() => handleNotificationClick(notification.id)}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                        {notification.type}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 1 }}>
                                        {notification.pesan}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: 'block' }}
                                    >
                                        {new Date(notification.created_at).toLocaleString('id-ID')}
                                    </Typography>
                                </Box>
                                <Divider />
                            </React.Fragment>
                        ))}
                    </Box>
                ) : (
                    <Box sx={{ p: 2 }}>
                        <Typography>No notifications available.</Typography>
                    </Box>
                )}
            </Dialog>
        </>
    );
};

export default NotificationBadge;
